import { Copy, QrCode, Download } from "lucide-react";
import { toast } from "sonner";
import { fileUrl } from "@/lib/api";

export const QrCard = ({ name, upi, qr }) => {
  const copy = () => { navigator.clipboard.writeText(upi); toast.success("UPI ID copied"); };
  return (
    <div className="mx-auto w-full min-w-0 max-w-sm rounded-2xl border border-slate-200 bg-white p-5 shadow-sm sm:p-6" data-testid="qr-card">
      <div className="text-xs font-semibold uppercase tracking-wider text-slate-400">Paying to</div>
      <div className="break-words font-display text-xl font-bold text-[#0A1F44]" data-testid="qr-merchant-name">{name}</div>
      <div className="mx-auto mt-5 grid aspect-square w-full max-w-[300px] place-items-center overflow-hidden rounded-xl border border-slate-200 bg-white p-2">
        {qr ? (
          <img src={fileUrl(qr)} alt="Static QR" className="h-full w-full object-contain" data-testid="qr-image" />
        ) : (
          <div className="text-center text-sm text-slate-400" data-testid="qr-empty"><QrCode className="mx-auto mb-2 h-10 w-10" />QR not assigned yet</div>
        )}
      </div>
      {upi ? (
        <button onClick={copy} data-testid="copy-upi-btn" className="mt-4 flex w-full items-center justify-between gap-3 rounded-lg bg-slate-50 px-4 py-3 text-left transition-colors hover:bg-slate-100">
          <span className="min-w-0 break-all font-mono text-sm text-slate-700" data-testid="qr-upi-id">{upi}</span>
          <Copy className="h-4 w-4 shrink-0 text-slate-400" />
        </button>
      ) : <div className="mt-4 rounded-lg bg-slate-50 px-4 py-3 text-center text-sm text-slate-400">UPI ID not assigned</div>}
      {qr && (
        <a href={fileUrl(qr)} target="_blank" rel="noreferrer" download data-testid="download-qr-btn" className="mt-3 flex items-center justify-center gap-2 text-sm font-semibold text-[#2563EB] hover:underline">
          <Download className="h-4 w-4" /> Open / Download QR
        </a>
      )}
      <p className="mt-4 text-center text-xs text-slate-400">Scan with any UPI app — GPay, PhonePe, Paytm, BHIM</p>
    </div>
  );
};
